import { Environment } from '@hashnode/urls'
import { DuplicatedPath, DuplicatedSlug } from './types'

export function checkForDuplicateSlugs(
	input: { slug: string; folderPath?: string; url?: string }[],
): DuplicatedSlug[] {
	const slugMap = new Map<string, { slug: string; folderPath?: string; url?: string }>()
	const duplicates: DuplicatedSlug[] = []

	for (const item of input) {
		if (slugMap.has(item.slug)) {
			const existingItem = slugMap.get(item.slug)!
			const duplicate: DuplicatedSlug = {
				slug: item.slug,
				guide: existingItem.folderPath
					? { configFilePath: existingItem.folderPath, slug: existingItem.slug }
					: { slug: existingItem.slug, url: existingItem.url! },
				otherGuide: item.folderPath
					? { configFilePath: item.folderPath, slug: item.slug }
					: { slug: item.slug, url: item.url! },
			}

			duplicates.push(duplicate)
		} else {
			slugMap.set(item.slug, item)
		}
	}

	return duplicates
}

// TODO: Needs to be changed for bi-directional sync
export function checkForDuplicatePaths(
	allPages: { path: string; filePath: string }[],
): DuplicatedPath[] {
	const pathMap = new Map<string, { path: string; filePath: string }>()
	const duplicates: DuplicatedPath[] = []

	for (const page of allPages) {
		if (pathMap.has(page.path)) {
			const existingPage = pathMap.get(page.path)!
			const duplicate: DuplicatedPath = {
				path: page.path,
				item: { filePath: existingPage.filePath, path: existingPage.path },
				otherItem: { filePath: page.filePath, path: page.path },
			}

			duplicates.push(duplicate)
		} else {
			pathMap.set(page.path, page)
		}
	}

	return duplicates
}

export const isNonNullable = <T>(value: T): value is NonNullable<T> =>
	value !== undefined && value !== null

/**
 * Get the matching web environment for the given AWS environment. Returns prod if not in a valid environment.
 */
export function getWebEnvironment(): Environment {
	if (!process.env.SST_STAGE) {
		return 'production'
	}

	switch (process.env.SST_STAGE) {
		case 'dev':
			return 'development'
		case 'staging':
			return 'staging'
		default:
			return 'production'
	}
}
